import { PayloadAction } from "@reduxjs/toolkit";

import { IState } from "../types";

const setSelectedCoordinates = (state: IState, action: PayloadAction<string>) => {
  state.selectedCoordinates = action.payload;
};

export default setSelectedCoordinates;